communication.matchtrackerModule = {
    // Funkcia na vykreslenie ovladacieho panelu matchtrackera
    panelRender: function (data) {
        var matchTrackerControlPanelInner = document.querySelector("#matchTrackerControlPanelInner");
        if ($("#event #eventInfo").is("[livefeed-reference]") && data && ($("#matchTrackerControlPanelInner").is(':empty') || (data.tabs.selected && (data.tabs.selected.length > $('.match-tracker-control-panel__tab-button').length)))) {
            matchTrackerControlPanelInner.innerHTML = "";
            matchTrackerControlPanelInner.insertAdjacentHTML("beforeend", `<span class='ui-icon-main match-tracker-control-panel__icon'></span><span class='match-tracker-control-panel__label'>${texts.DetailMatchtrackerPanel}</span>`);
            // MT control taby
            data.tabs.selected.forEach(function(selectedTab) {
                if (selectedTab.subTabs && selectedTab.subTabs.length) {
                    if (matchTrackerControlPanelInner) {
                        matchTrackerControlPanelInner.insertAdjacentHTML("beforeend", `
                            <a
                                class="match-tracker-control-panel__tab-button"
                                id="selectstatistics"
                                data-role="none"
                                onclick="player.playerSettingsModule.userSettingsSelectToggle('statistics'); communication.matchtrackerModule.topScreenControlMT('${data.tabs.type}', '${data.tabs.selector}', '${data.tabs.findSelector}', '${selectedTab.tabIndex}'); communication.matchtrackerModule.topScreenControlMT('${selectedTab.type}', '${selectedTab.selector}', '${selectedTab.findSelector}', '0');"
                            >
                                ${selectedTab.tabText}
                                <span class='icon icon-arrow-up'></span>
                            </a>
                            <div id="userSettingsstatisticsSelect" class="select-menu match-tracker-control-panel__statistics-select">
                                <div class="match-tracker-control-panel__triangle-wrap">
                                    <div class="match-tracker-control-panel__triangle">
                                    </div>
                                </div>
                            <div class="match-tracker-control-panel__statistics-list">
                                <div class="match-tracker-control-panel__select-group">
                                    ${selectedTab.subTabs.map(function (subT, subTi) {
                                        return `
                                            <a
                                                class="match-tracker-control-panel__sub-tab-button"
                                                id="matchTrackerControlSubButton${subTi.toString()}"
                                                data-role="none"
                                                onclick="communication.matchtrackerModule.topScreenControlMT('${data.tabs.type}', '${data.tabs.selector}', '${data.tabs.findSelector}', '${selectedTab.tabIndex}'); communication.matchtrackerModule.topScreenControlMT('${selectedTab.type}', '${selectedTab.selector}', '${selectedTab.findSelector}', '${subTi.toString()}');"
                                            >
                                                ${subT.tabText}
                                            </a>
                                        `;
                                    }).join("")}
                                </div>
                            </div>
                        `);
                    }
                } else {
                    if (matchTrackerControlPanelInner) {
                        matchTrackerControlPanelInner.insertAdjacentHTML("beforeend", `
                            <a
                                class="match-tracker-control-panel__tab-button"
                                id="matchTrackerControlButton${selectedTab.tabIndex}"
                                data-role="none"
                                onclick="communication.matchtrackerModule.topScreenControlMT('${data.tabs.type}', '${data.tabs.selector}', '${data.tabs.findSelector}', '${selectedTab.tabIndex}', true);"
                            >
                                ${selectedTab.tabText}
                            </a>
                        `);
                    }
                }
            });
            // MT control panel sipky
            Object.keys(data.arrows.selected).forEach(function(arrowKey) {
                if (matchTrackerControlPanelInner) {
                    matchTrackerControlPanelInner.insertAdjacentHTML("beforeend", `
                        <a
                            class="match-tracker-control-panel__arrow-button"
                            data-role="none"
                            onclick="communication.matchtrackerModule.topScreenControlMT('${data.arrows.type}', '${data.arrows.selector}', '${data.arrows.findSelector}', '${data.arrows.selected[arrowKey].shift}');"
                        >
                            <div class='${data.arrows.selected[arrowKey].icon}'></div>
                        </a>
                    `);
                }
            });
            $("#matchTrackerControlPanelInner").trigger("create");
            if (data.tabs && data.tabs.selected && data.tabs.selected[0]?.subTabs && data.tabs.selected[0]?.subTabs.length) {
                communication.matchtrackerModule.topScreenControlMT("subTabs", data.tabs.selected[0].selector, data.tabs.selected[0].findSelector, "0");
            } else {
                // Nastavenie 1. MT control tabu ako default
                communication.matchtrackerModule.topScreenControlMT("tabs", data.tabs.selector, data.tabs.findSelector, "0");
            }
        }
    },

    // Funkcia na poslanie prikazu prepnutia tabu na vrchnej obrazovke v matchtrackery
    topScreenControlMT(type, selector, findSelector, selected, notSelectbox) {
        modal.hideTooltip();
        if (type === "subTabs") {
            $(".match-tracker-control-panel__sub-tab-button").removeClass("match-tracker-control-panel__sub-tab-button--active");
            $("#matchTrackerControlSubButton" + selected).addClass("match-tracker-control-panel__sub-tab-button--active");
            // Najskor zavola hlavny tab
            setTimeout(function() {
                communication.topScreen("matchTrackerControl", {
                    type: type,
                    selector: selector,
                    findSelector: findSelector,
                    selected: selected
                });
            }.bind(this), 50);
            return true;

        } else if (type === "tabs") {
            if (notSelectbox) {
                player.playerSettingsModule.userSettingsSelectToggle("statistics", true);
            }
            // Oznacenie aktivneho tabu
            $(".match-tracker-control-panel__tab-button").removeClass("match-tracker-control-panel__tab-button--active");
            $("#matchTrackerControlButton" + selected).addClass("match-tracker-control-panel__tab-button--active");
        }
        communication.topScreen("matchTrackerControl", {
            type: type,
            selector: selector,
            findSelector: findSelector,
            selected: selected
        });
    },

};
